import { Check, X } from "lucide-react";

// Case à 3 états pour un résultat de test de diagnostic : clic pour faire
// défiler non testé (vide) -> valide (✓) -> invalide (✗) -> non testé.
// Reprise et intervention partagent ce même composant.
export function TristateCheckbox({ state, onChange, disabled, testId }) {
  const cycle = () => {
    if (disabled) return;
    if (!state) onChange("valide");
    else if (state === "valide") onChange("invalide");
    else onChange(null);
  };

  return (
    <button
      type="button"
      onClick={cycle}
      disabled={disabled}
      data-testid={testId}
      data-state={state || "non_teste"}
      title={state === "valide" ? "Valide" : state === "invalide" ? "Mauvais / HS" : "Non testé — cliquer pour marquer"}
      className={`w-5 h-5 rounded border flex items-center justify-center shrink-0 transition-colors ${
        state === "valide"
          ? "bg-emerald-500 border-emerald-500 text-white"
          : state === "invalide"
            ? "bg-destructive border-destructive text-white"
            : "border-border bg-background hover:border-muted-foreground"
      } ${disabled ? "opacity-60 cursor-default" : "cursor-pointer"}`}
    >
      {state === "valide" && <Check size={13} strokeWidth={3} />}
      {state === "invalide" && <X size={13} strokeWidth={3} />}
    </button>
  );
}
